module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }